import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'interiorPackages', 'steeringWheels'],
};

const sq6etron_2025_GF: PartialCarConfiguration = {
	...q6,
};

const q6etron_2025_GF: PartialCarConfiguration = {
	...q6,
};

const q6etron_2025_GF_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq6etron_2025_GF_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q6etron_2025_GF, q6etron_2025_GF_ui, sq6etron_2025_GF, sq6etron_2025_GF_ui };
